/**
 * @namespace random
 * @since 2.1.0
 */

import { uid } from './uid';

const random = {
    uid
};

export {
    random,
    uid
};
